<template>
<div :class="bdata.blockType === BTPS().IMAGELINK && bdata.blockState == 0 ? 'hidden' : ''">
  <div
    class="contentblock board_layout"
    :data-block-id="bdata.paperBlockId"
  >
    <ContentBlockCreatorInfo
      :bdata ="bdata"
      :blockModDate="blockModDate"
      :blockRegDate="blockRegDate"
      :blockModUserName="blockModUserName"
      :blockRegUserName="blockRegUserName"
      :modUserExceptBlocktype="bdata.blockType">
    </ContentBlockCreatorInfo>
    <div class="eidtbox-ty1"
      :class="state.toggleImage != 'Y' ? 'attachfile_box' : 'align_top'">
      <div class="row_box clear hover_box">
        <!-- [rowbox] -->
        <div class="hover_inner">
          <!-- [드래그 핸들] -->
          <!-- 보이는 드래그 핸들 -->
          <div class="move"></div>
          <!-- 실제 이벤트 드래그 핸들 -->
          <div class="block_handle" ref="dragHandle"
            :data-block-id="bdata.paperBlockId"
            :transfer-data="bdata.paperBlockId"
            @mousedown="dragBlockState(1)"
            @mouseup="dragBlockState(0)"
            @touchstart="dragBlockState(1)"
            @touchend="dragBlockState(0)">
            &nbsp;
          </div>
          <!-- /[드래그 핸들] -->
          <div>
            <!-- [이미지타입 블럭] -->
            <div class="file_row clear"
              :class="state.toggleImage == null ? '' : 'hidden'">
              <div class="file_name ell-singleline"
                :class="'ico-file-' + iconType()"
                @click="callFileViewer"
              >
                {{ bdata.contentPath == "" ? "image.jpg" : bdata.contentPath }}
              </div>
              <div class="btn">
                <button type="button"
                  class="img_zoom permit_everyone"
                  @click="changeToggleImage(state.toggleImage)">
                  {{$i18nUtil.trans("message.ContentBlockTypeImage.001","이미지 확대 축소")}}
                </button>
                <div class="droplayer icon more large right nosel">
                  <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="permit_everyone" v-bind="attrs" v-on="on">{{$i18nUtil.trans("button.more","더보기")}}</v-btn>
                    </template>
                    <div class="dropdown-list">
                      <div class="dropdown-list-item">
                        <div class="tit">
                          <button
                            type="button"
                            @click="downloadFile"
                          >
                            {{$i18nUtil.trans("button.file.download","다운로드")}}
                          </button>
                        </div>
                      </div>
                      <div class="dropdown-list-item">
                        <div class="tit">
                          <button
                            type="button"
                            @click="copyURL"
                          >
                            {{$i18nUtil.trans("button.url.copy","URL 복사")}}
                          </button>
                        </div>
                      </div>
                      <div class="dropdown-list-item">
                        <div class="tit">
                          <button
                            type="button"
                            @click="deleteFileBlock"
                          >
                            {{$i18nUtil.trans("button.file.delete","파일 삭제")}}
                          </button>
                        </div>
                      </div>
                    </div>
                  </v-menu>
                </div>

              </div>
            </div>
            <div
              v-if="!bdata.blockState"
              class="img_box"
              :class="state.toggleImage === 'Y' ? '' : 'hidden'">

              <div class="one">
                <div v-if="state.loading">
                  <ProgressCircle :width="100" :height="100"></ProgressCircle>
                </div>
                <img
                  @click="callFileViewer"
                  class="preview" :class="state.loading ? 'hidden' : ''" />
                <div class="btn">

                  <button type="button"
                    class="img_zoom active permit_everyone"
                    @click="changeToggleImage(state.toggleImage)">
                    {{$i18nUtil.trans("message.ContentBlockTypeImage.001","이미지 확대 축소")}}
                  </button>
                  <div class="droplayer icon more large right nosel">
                    <v-menu bottom left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on">{{$i18nUtil.trans("button.more","더보기")}}</v-btn>
                      </template>
                      <div class="dropdown-list">
                        <div class="dropdown-list-item">
                          <div class="tit">
                            <button
                              type="button"
                              @click="downloadFile"
                            >
                              {{$i18nUtil.trans("button.file.download","다운로드")}}
                            </button>
                          </div>
                        </div>
                        <div class="dropdown-list-item">
                          <div class="tit">
                            <button
                              type="button"
                              @click="boardUtil.copyClipboard(getFileUrl())"
                            >
                              URL 복사{{$i18nUtil.trans("message.BoardEditor.005","파일추가")}}
                            </button>
                          </div>
                        </div>
                        <div class="dropdown-list-item">
                          <div class="tit">
                            <button
                              type="button"
                              @click="deleteFileBlock"
                            >
                              {{$i18nUtil.trans("button.file.delete","파일 삭제")}}
                            </button>
                          </div>
                        </div>
                      </div>
                    </v-menu>
                  </div>
                </div>
              </div>
            </div>
            <!-- /[이미지타입 블럭] -->
          </div>
          <!-- [의견 영역] -->
          <div
            v-if="!bdata.blockState"
            ref="buttonComment"
            class="hover_comment"
            :class="
            (commentCount ? ' display-block' : '') +
            (blockInfo.commentSelectId === bdata.paperBlockId ? ' display-block active' : '')
            "
            >
            <button type="button" class="permit_everyone" @click="viewComment">
              {{ !commentCount ? "" : commentCount }}
            </button>
          </div>
          <!-- /[의견 영역] -->
        </div>
        <!-- /[rowbox] -->
        <div v-if="bdata.blockState" class="loading-box white">
          <div class="loader_wrap">
            <div class="loader">{{$i18nUtil.trans("message.ContentBlockTypeFile.002","파일 업로드 중입니다.")}}</div>
            <div class="loader-txt">{{$i18nUtil.trans("message.ContentBlockTypeFile.002","파일 업로드 중입니다.")}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <img class="noimg hidden" src="@/assets/img/noimg.png"/>
</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ProgressCircle from "../extensions/ProgressCircle";
import ContentBlockCreatorInfo from "./ContentBlockCreatorInfo";

export default {
  components: {
    ProgressCircle,
    ContentBlockCreatorInfo,
  },
  props: {
    paperInfo: Object,
    blockInfo: Object,
    boardMemberInfo: Object,
    boardSection: Array,
    bdata: Object,
    transmitter: Object,
    userInfo: Object,
    paperBlockIdList: Array,
    paperBlockMap: Object,
    boardUtil: Object,
    context: Object,
    memberSelector: Object,
  },
  data() {
    return {
      pdata: this.bdata,
      editable: false,
      keepInBounds: true,
      loading: true,
      messageList: [],
      files: [],
      fileUploadType: null,
      state: {
        toggleImage: null,
        loading: true,
      },
      userList: [],
      commentCount: this.blockInfo.commentCounts[this.bdata.paperBlockId],
      members: this.boardMemberInfo.userList,
      opinionUpfile: {
        groupId: String(this.paperInfo.groupId),
        paperId: String(this.paperInfo.paperId),
        files: []
      },
      files: [],
      commentItems:[],
      commentView:false,

      blockModDate : '',
      blockRegDate: '',
      blockModUserName:'',
      blockRegUserName:'',
    };
  },
  created() {
    this.context.eventBusProc(this);
    this.context.initContentBlock(this);
  },
  mounted() {
    let self = this;
    self.transmitter.subscribers[self.bdata.paperBlockId] = {
      subscribe: (command, data, error) => {
        self.stompEditorSubscribe(command, data, error);
      }
    };
    self.onConnected();
    /* IMAGELINK는 숨김위젯이므로 따로 이미지를 불러오지 않는다. (본문에서 불러짐) */
    if (self.bdata.blockType === self.BTPS().IMAGE) {
      let imageElement = self.$el.querySelector(".img_box .one img.preview");
      if (imageElement) {
        self.HW_LOAD_IMAGE({img:imageElement, groupId:self.paperInfo.groupId,
          paperId:self.paperInfo.paperId, fileId:self.bdata.fileId,
          callback(status) {
            if(status){
              self.state.loading = false;
              if(self.bdata.blockOpenYn == 1 ){
                self.state.toggleImage = 'Y';
              }
            }
            // 이미지 로드가 완료된후에 블럭이동을 위해서 다른 contentBlocktype*.vue 와는 위치가 다름.
            self.$emit("blockMatch");
          }
        });
      }
    }
    this.renderCompleted();
  },
  computed:{
    ...mapState("noti", ["notiBoardBlockId"]),
  },
  updated() { },
  beforeDestroy() {
    delete this.transmitter.subscribers[this.bdata.paperBlockId];
  },
  watch: {
    "pdata.blockState"() { },
    "pdata.fileId"() { },
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("coworkUtils", ["HW_LOAD_IMAGE"]),
    stompEditorSubscribe(command, bdata, error) {
      let updateToken = null;
      if (command === "content") {
        if (bdata.paperId === this.paperInfo.paperId &&
          bdata.paperBlockId === this.bdata.paperBlockId) {
          let toastMsg = "";
          if (this.bdata.regUserId === this.userInfo.userId &&
            !error.code && error.message == "UPLOAD_SUCCESS") {
            if(bdata.modDate != null){
              this.blockModDate = bdata.modDate;
              this.blockModUserName = this.$i18nUtil.getLanguage() === 'en' && bdata.blockLockNameEn !== null ? bdata.blockLockNameEn : bdata.blockLockName;
            }
            if(bdata.regDate != null){
              this.blockRegDate = bdata.regDate;
              this.blockRegUserName = this.$i18nUtil.getLanguage() === 'en' && bdata.regUserNameEn !== null ? bdata.regUserNameEn : bdata.regUserName;
            }
            toastMsg = this.$i18nUtil.trans("message.OutputBoard.003","파일이 정상적으로 업로드 되었습니다.");
          }
          if (toastMsg) {
            this.toast(toastMsg);
          }
          updateToken = bdata.updateToken;
          if (updateToken && this.boardUtil.findUpdateToken(updateToken) != -1) {
            /* 전파자가 보낸신호는 되받지 않음 */
            this.boardUtil.removeUpdateToken(updateToken);
            return true;
          }
          this.bdata.contentPath = bdata.content;
          this.bdata.blockState = Number(bdata.blockState);
          this.bdata.fileId = bdata.fileId;
          this.bdata.blockOpenYn = bdata.blockOpenYn;
          this.$nextTick(() => {
            let imageElement = this.$el.querySelector(".img_box .one img.preview");
            if (imageElement) {
              let self = this;
              setTimeout(() => {
                self.HW_LOAD_IMAGE({img:imageElement, groupId:self.paperInfo.groupId,
                  paperId:self.paperInfo.paperId, fileId:self.bdata.fileId,
                  callback() { 
                    self.state.loading = false;
                    if(self.bdata.blockOpenYn == 1){
                      self.state.toggleImage = 'Y'; 
                    }
                  }
                });
              }, 1000);
            }
          });
          return true;
        }
      }
      return false;
    },
    iconType() {
      let fileName = this.bdata.contentPath;
      let type = this.boardUtil.fileExt(fileName);
      let ext = "img";
      if (type[0] && type[0].length >= 3) {
        ext = type[0].substring(0, 3);
        if (type[0] === "tiff") {
          ext = type[0]
        }
        else if (ext === "jpg" || ext === "gif" || ext === "png" || ext === "tif" || ext === "bmp") {
          // NO-OP
        }
        else {
          ext = "img";
        }
      }
      return ext;
    },
    callFileViewer(e) {
      let link = document.createElement("a");
      link.setAttribute("href", this.getFileUrl(true));
      link.setAttribute("target", "_blank");
      link.click();
      // this.$router.push( this.getFileUrl(true));
    },
    deleteFileBlock(e) {
      let self = this;
      /* 권한체크 RW = permission 2 */
      if (self.paperInfo.permission > 1) {
        self.deleteModal(self.$i18nUtil.trans("AG001"), (modal) => {
          modal.close();
          self.deleteBlock({ callback(res) {
            if (res && res.data && !res.data.errorCode) {
              self.boardUtil.removeBlockData(self.bdata.paperBlockId);
              let toastMsg = self.$i18nUtil.trans("TB011");
              self.toast(toastMsg);
            }
          }});
        });
      }
      else {
        /* 권한이 없습니다 */
        let toastMsg = this.$i18nUtil.trans("TB044");
        this.toast(toastMsg);
      }
    },
    opinionCreate() {
      /* 의사결정 위젯을 띄운다 */
      let el = this.$refs.opinionForm;
      el.classList.toggle("hidden");
      console.log("show opinion create form");
    },
    noticeDownloadFail(){
      this.showAlertDialog(this.$i18nUtil.trans("AB077"));
    },
    noticeDownloadFailFromExternal() {
      this.showAlertDialog(this.$i18nUtil.trans("AB101"));
    },
    notAuthorizedDownloadFail(){
      let toastMsg = this.$i18nUtil.trans("TB044");
      this.toast(toastMsg);
    },
    copyURL() {
      this.boardUtil.copyClipboard(this.getFileUrl());
      let toastMsg = this.$i18nUtil.trans("TB010");
      this.toast(toastMsg);
    },
    changeToggleImage(toggleImageKey){
      let self = this;
      if(toggleImageKey == "Y"){
        self.state.toggleImage = null;
      }else{
        self.state.toggleImage = "Y";
      }

      let action = "/api/copaper/paper/changeToggleOpenYn";
      let param = {
        paperBlockId: self.bdata.paperBlockId,
        blockOpenYn: self.state.toggleImage == "Y" ? '1':'0'
      };
      self.COWORK_REST_ACTION({
        url: action,
        method: "post",
        req: param
      })
      .then(res => {})
      .catch(function(err) { console.log(err); });
    }
  },
};
</script>

<!-- 지역스타일 지정 -->
<style scoped>
.one {
  text-align: center;
}
.one .v-progress-circular {
  margin: 150px 0 0 0;
}

.droplayer.more.large > .v-btn {
  background-color: rgba(246,247,372,0.5);
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/board/editor/ContentBlockTypeImage.vue